module.exports = __webpack_public_path__ + "static/media/Locklock.03b98466.svg";